export const BlockedLogRocketRoutes = [
  'customer/search',
  'customer/get',
  'logcontactinfo',
  'depositaccounts',
  'getoneallyaccounts',
  'setdepositaccount',
  'plaidinit',
  'depositfunds',
  'initiateachtransfer',
  'initiateoneallytransfer',
  'createachprofile',
  'postdocuments',
  'verifykba',
];
